import { GetServerSidePropsContext } from 'next'

import ArticlePage from '@/components/Wordpress/ArticlePage/ArticlePage'
import GuidePage from '@/components/Wordpress/GuidePage/GuidePage'
import { getPage, getPost } from '@/services/wordpress.service'
import { PageType, PostType } from '@/types/wordpress'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

type Props = {
  enableAdhesion: boolean
  post: PostType
}

const ArticlesSubPage = ({ enableAdhesion, post }: Props) => {
  if (post.categories?.includes('guide')) {
    return <GuidePage enableAdhesion={enableAdhesion} post={post as PostType} /> // For preview mode
  }
  return <ArticlePage enableAdhesion={enableAdhesion} post={post} />
}

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext) => {
  const slug = params!.slug as string

  // First try to get a post
  let post = (await getPost({ slug })) as PostType | PageType | undefined

  if (!post) {
    // If no post is found, try to get a page
    post = await getPage({ slug })

    if (!post) return { notFound: true }
  } else if ((post as PostType).categories?.includes('guide')) {
    return {
      redirect: {
        destination: `/guides/${slug}`,
        permanent: true,
      },
    }
  }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  return {
    props: { enableAdhesion: true, post },
  }
}

export default ArticlesSubPage
